<template>
  <div>
    <h2 class="mb-4">
      <i class="fa-duotone fa-rectangle-list text-warning fa-fw"></i> {{ translate("audit_logs") }}
    </h2>
    <CollectionView :endpoint="utilities.path('communities/@/modules/auditLogs/logs', communityId)" :params="{ actions: selectedActions }" v-model:reload="reload" default-order="createdAt:desc">
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between">
          <h4 class="mb-0">{{ translate("logs") }}</h4>
          <HttpContentView :endpoint="utilities.path('communities/@/modules/auditLogs/actions', communityId)">
            <template v-slot:content="{ data }">
              <SelectInputView style="width: 160px; max-width: 100%;" v-model:value="selectedActions" size="small" :options="data.map(item => ({ id: item.key, title: item.title, icon: item.icon }))" multiple>
                <template v-slot:option="{ option, preview }">
                  <span class="mx-1">
                    <i v-if="preview" :class="option.icon"></i>
                    <div v-else class="d-flex align-items-center g-2">
                      <i :class="option.icon"></i>
                      <span>{{ option.title }}</span>
                    </div>
                  </span>
                </template>
              </SelectInputView>
            </template>
          </HttpContentView>
        </div>
      </template>
      <template v-slot:content="{ items }">
        <div class="card">
          <div class="table-responsive">
            <div class="table">
              <div class="table-header">
                <div class="table-header-cell">{{ translate("user") }}</div>
                <div class="table-header-cell">{{ translate("target") }}</div>
                <div class="table-header-cell">{{ translate("action") }}</div>
                <div class="table-header-cell">{{ translate("created_at") }}</div>
                <div class="table-header-cell">{{ translate("actions") }}</div>
              </div>
              <div class="table-body">
                <div class="table-row" v-for="item in items" :key="item.id">
                  <div class="table-column">
                    <UserView :user="item.user"/>
                  </div>
                  <div class="table-column">
                    {{ item.target }}
                  </div>
                  <div class="table-column">
                    <i :class="item.action.icon" class="fa-lg"></i>
                  </div>
                  <div class="table-column">{{ utilities.formatDatetime(item.createdAt) }}</div>
                  <div class="table-column">
                    <div class="d-flex align-items-center g-2">
                      <ButtonView type="soft" color="primary" size="small" @click="viewId = item.id">
                        <i class="fas fa-eye"></i>
                      </ButtonView>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CollectionView>
    <ModalView :active="viewId !== undefined" @update:active="viewId = undefined">
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between">
          <h3 class="mb-0">{{ translate("audit_log") }}</h3>
          <ModalCloseButtonView @click="viewId = undefined"/>
        </div>
      </template>
      <template v-slot:body>
        <HttpContentView v-if="viewId" :endpoint="utilities.path('modules/auditLogs/logs/@', viewId)">
          <template v-slot:content="{ data: log }">
            <div class="row g-4">
              <div class="col-6">
                <h5 class="mb-2 text-white">{{ translate("user") }}</h5>
                <UserView :user="log.user"/>
              </div>
              <div class="col-6">
                <h5 class="mb-2 text-white">{{ translate("target") }}</h5>
                <div>{{ log.target }}</div>
              </div>
              <div class="col-6">
                <h5 class="mb-2 text-white">{{ translate("action") }}</h5>
                <div class="d-flex align-items-center g-2">
                  <i :class="log.action.icon"></i>
                  <span>{{ log.action.title }}</span>
                </div>
              </div>
              <div class="col-12" v-if="log.details">
                <h5 class="mb-3">{{ translate("details") }}</h5>
                <div class="card">
                  <div class="card-body p-3">
                    <div class="d-flex">
                      <div class="w-100" v-if="log.details.before">
                        <h5 v-if="log.details.after !== undefined">{{ translate("before") }}</h5>
                        <div class="d-flex flex-column g-2">
                          <AuditLogDetail v-for="(detail, index) in log.details.before" :key="index" :detail="detail"/>
                        </div>
                      </div>
                      <div class="w-100" v-if="log.details.after">
                        <h5 v-if="log.details.before !== undefined">{{ translate("after") }}</h5>
                        <div class="d-flex flex-column g-2">
                          <AuditLogDetail v-for="(detail, index) in log.details.after" :key="index" :detail="detail"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </HttpContentView>
      </template>
    </ModalView>
  </div>
</template>

<script setup>
import {HttpContentView, SelectInputView, utilities, ModalView, CollectionView, ButtonView, ModalCloseButtonView} from "@niftybit/vue";
import AuditLogDetail from "@/systems/modules/auditLogs/AuditLogDetail.vue";
import {ref} from "vue";
import UserView from "@/components/other/UserView.vue";

defineProps({
  communityId: String
});

const reload = ref(false);
const selectedActions = ref([]);
const viewId = utilities.routeQueryParam("viewId");

</script>